// extracted by mini-css-extract-plugin
export default {"main":"styles_main__bOD+S","active":"styles_active__U-Ri3"};